import { render, staticRenderFns } from "./transferJNJUser.vue?vue&type=template&id=d110cc92&"
import script from "./transferJNJUser.vue?vue&type=script&lang=js&"
export * from "./transferJNJUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports